var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 12.125H6.25V6.5C6.25 5.50544 6.64509 4.55161 7.34835 3.84835C8.05161 3.14509 9.00544 2.75 10 2.75C10.9946 2.75 11.9484 3.14509 12.6516 3.84835C13.3549 4.55161 13.75 5.50544 13.75 6.5H15.625C15.625 5.00816 15.0324 3.57742 13.9775 2.52252C12.9226 1.46763 11.4918 0.875 10 0.875C8.50816 0.875 7.07742 1.46763 6.02252 2.52252C4.96763 3.57742 4.375 5.00816 4.375 6.5V12.125H2.5C2.00272 12.125 1.52581 12.3225 1.17417 12.6742C0.822544 13.0258 0.625 13.5027 0.625 14V25.25C0.625 25.7473 0.822544 26.2242 1.17417 26.5758C1.52581 26.9275 2.00272 27.125 2.5 27.125H17.5C17.9973 27.125 18.4742 26.9275 18.8258 26.5758C19.1775 26.2242 19.375 25.7473 19.375 25.25V14C19.375 13.5027 19.1775 13.0258 18.8258 12.6742C18.4742 12.3225 17.9973 12.125 17.5 12.125ZM17.5 25.25H2.5V14H17.5V25.25Z",
    fill: "#DDDFDD"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.9d9ad97896a624765739ad7789feeed9.svg";
export { ForwardRef as ReactComponent };